import PaletteFromImage from "../../../../src/components/pages/image-from-palette/PaletteFromImage";
import * as React from 'react';
export default {
  PaletteFromImage,
  React
};